export default __webpack_public_path__ + "static/media/Resize.6ecf32f6.svg";